import Repository from './Repository';

import { vue } from '../main';
import InstanceRepository from './InstanceRepository';

const baseUrl = process.env.VUE_APP_API_URL;
const base = `${baseUrl}/event`;


export default {
  /**
	 * List all events
	 *
	 * @returns {Promise<AxiosResponse<T> | never>}
	 */
  list() {
    return Repository.post(`${base}/list`);
  },
  /**
	 * Reloads the event list and pushes it to the store.
	 *
	 * @returns {Promise<T>}
	 */
  async refetchList() {
    return await this.list()
      .then((response) => {
        vue.$store.dispatch('setEvents', response.data.list);
        return Promise.resolve(response);
      }).catch((error) => {
        Promise.reject(error);
      });
  },
  /**
	 * Adds an event to the eventlist.
	 *
	 * @param name
	 * @param isChapter
	 * @returns {Promise<AxiosResponse<T>>}
	 */
  add(name, isChapter) {
    return Repository.post(`${base}/add`, {
      name,
      isChapter: isChapter === 'true' || isChapter === true,
    });
  },
  /**
	 * Deletes an event from the eventlist.
	 *
	 * @param eventId
	 * @returns {Promise<AxiosResponse<T>>}
	 */
  delete(eventId) {
    return Repository.post(`${base}/delete`, {
      id: eventId,
    });
  },
};
